export default {"src":"/_next/static/media/youtube-logo.6ec8273d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};